import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FertilityState } from '../../models/fertility.model';

export const getFertilityState = createFeatureSelector<FertilityState>('fertility');
export const getCows = createSelector(getFertilityState, (state: FertilityState) => state?.cows);
export const getFertilitySummary = createSelector(
  getFertilityState,
  (state: FertilityState) => state?.fertilitySummary,
);
